// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tabs_tab__3sagy","active":"Tabs_active__DkH7u","pane":"Tabs_pane__1GuLn"};